import { Component, ElementRef, HostBinding, HostListener, Input, OnInit } from '@angular/core';

export type DsButtonVariant = 'primary' | 'secondary';
export type DsButtonSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'button[app-ds-button]',
  templateUrl: './ds-button.component.html',
  styleUrls: ['./ds-button.component.scss']
})
export class DsButtonComponent implements OnInit {
  @Input() variant: DsButtonVariant = 'primary';
  @Input() size: DsButtonSize = 'md';
  @Input() loading = false;
  @Input() disabled = false;

  @HostBinding('class.ds-button') readonly hostClass = true;

  @HostBinding('class.ds-button--primary')
  get primaryClass(): boolean { return this.variant === 'primary'; }

  @HostBinding('class.ds-button--secondary')
  get secondaryClass(): boolean { return this.variant === 'secondary'; }

  @HostBinding('class.ds-button--sm')
  get smClass(): boolean { return this.size === 'sm'; }

  @HostBinding('class.ds-button--md')
  get mdClass(): boolean { return this.size === 'md'; }

  @HostBinding('class.ds-button--lg')
  get lgClass(): boolean { return this.size === 'lg'; }

  @HostBinding('class.ds-button--loading')
  get loadingClass(): boolean { return this.loading; }

  @HostBinding('attr.disabled')
  get disabledAttr(): string | null {
    return (this.disabled || this.loading) ? '' : null;
  }

  @HostBinding('attr.aria-busy')
  get ariaBusy(): string | null {
    return this.loading ? 'true' : null;
  }

  constructor(private elementRef: ElementRef<HTMLButtonElement>) {}

  ngOnInit(): void {
    if (!this.elementRef.nativeElement.hasAttribute('type')) {
      this.elementRef.nativeElement.setAttribute('type', 'button');
    }
  }

  @HostListener('click', ['$event'])
  onHostClick(event: Event): void {
    if (this.loading || this.disabled) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }
}
